// Derived server-side (controllers/sales/SalesOrderController.js) from amountPaid vs the order's
// own computed total - not a stored workflow status.
export const resolvePaymentStatusVariant = status => {
  if (status === 'Paid') return 'light-success'
  if (status === 'Partially Paid') return 'light-warning'
  if (status === 'Overpaid') return 'light-info'
  if (status === 'Pending') return 'light-secondary'
  return 'light-primary'
}

export const resolvePaymentStatusLabel = status => status || '–'
